import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="container footer__container">
        <div className="footer__1">
          <Link to="/Home" className="footer__logo">
            <h4>Jee Vision</h4>
          </Link>
          <p>
            JEE Vision Coaching offers expert mathematics tuition for classes
            11th and 12th, specializing in JEE, NIT, and competitive exams.
          </p>
        </div>

        <div className="footer__2">
          <h4>Permalinks</h4>
          <ul className="permalinks">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/About">About</Link>
            </li>
            <li>
              <Link to="/Courses">Courses</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/Contact">Contact</Link>
            </li>
            <li>
              <Link to="/fees">Coaching Fees</Link>
            </li>
          </ul>
        </div>

        <div className="footer__3">
          <h4>Privacy</h4>
          <ul className="privacy">
            <li>
              <Link to="/PrivacyPolicy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/TermsAndConditions">Terms and Conditions</Link>
            </li>
            <li>
              <Link to="/RefundPolicy">Refund Policy</Link>
            </li>
          </ul>
        </div>

        <div className="footer__4">
          <h4>Contact Us</h4>
          <div>
            <p>+91 7979051640</p>
            <p>+91 7654227845</p>
            <p>chetan09shree@gmail.com</p>
          </div>
          <ul className="footer__socials">
            <li>
              <a href="https://www.facebook.com/p/Jee-vision-purnea-100057438309447/">
                <i className="fab fa-facebook-square"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/jeevision_official/">
                <i className="fab fa-instagram-square social-icon"></i>
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCIEy6MlPqCr2KoaJi332VZg">
                <i className="fab fa-youtube-square social-icon"></i>
              </a>
            </li>
            <li>
              <Link to="/LinkedIn">
                <i className="fab fa-linkedin social-icon"></i>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="creater">
        &lt;/&gt; with ❤ by{" "}
        <span className="rk">
          <a
            href="https://rohan-codes.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Developer Rohan
          </a>
        </span>
      </div>
      <div className="footer__copyright">
        <small>Copyright &copy; Jee Vision 2024 </small>
      </div>
    </footer>
  );
};

export default Footer;
